import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const AnimatedLink = ({ className, url, label, color, hoverColor, openInNewTab, linkClassName }) => {
    return (_jsx("div", { className: cn(className), children: _jsx("a", { href: url, target: openInNewTab ? "_blank" : "", className: cn("animated-link inline", {
                "text-lighter-black": color === "lighter-black",
                "text-bdo-red": color === "bdo-red",
                "text-white": color === "white",
                "text-cta-blue": color === "cta-blue",
                "text-charcoal": color === "charcoal",
                "text-black": color === "black" || !color,
                "hover:text-lighter-black": hoverColor === "lighter-black",
                "hover:text-bdo-red": hoverColor === "bdo-red",
                "hover:text-white": hoverColor === "white",
                "hover:text-cta-blue": hoverColor === "cta-blue",
                "hover:text-charcoal": hoverColor === "charcoal",
                "hover:text-black": hoverColor === "black" || !hoverColor
            }, linkClassName), children: _jsx("span", { className: "hover-underline", dangerouslySetInnerHTML: { __html: label } }) }) }));
};
export default AnimatedLink;
